import React, {useState, useEffect} from "react";
import {Card, CardBody, Container, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import classnames from 'classnames';
import PreferencesAttendanceControl from "./Presence/PreferencesAttendanceControl";
import PreferencesCompanyConfigAccreditation from "./Accreditation/PreferencesCompanyConfigAccreditation";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import './assets/css/PreferencesPage.css';
import PreferencesCompanyConfigAccreditationNotification
    from "./Accreditation/PreferencesCompanyConfigAccreditationNotification"; // Importa o CSS personalizado

const PreferencesPage = () => {
    document.title = "Preferência | Plantão Rápido";

    const [activeTab, setActiveTab] = useState("2");
    const [functionsArray, setFunctionsArray] = useState([]);
    useEffect(() => {
    }, []);







    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Preferência" pageTitle="Configuração"/>
                    <Row>
                        <Col md={2}>
                            <Nav vertical pills className="preferences-tabs">
                                <NavItem>
                                    <NavLink
                                        className={classnames("preferences-tab-item", { active: activeTab === "2" })}
                                        onClick={() => setActiveTab("2")}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Credenciamento
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames("preferences-tab-item", { active: activeTab === "3" })}
                                        onClick={() => setActiveTab("3")}
                                        style={{ cursor: 'pointer' }}
                                    >
                                         Credenciamento Vencimento
                                    </NavLink>
                                </NavItem>

                                    <NavItem>
                                        <NavLink
                                            className={classnames("preferences-tab-item", { active: activeTab === "1" })}
                                            onClick={() => setActiveTab("1")}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Regras por Departamento/Local
                                        </NavLink>
                                    </NavItem>

                            </Nav>
                        </Col>

                        <Col md={10} className="pe-md-5">
                            <TabContent activeTab={activeTab} className="p-0">
                                <TabPane tabId="1">
                                    <PreferencesAttendanceControl />
                                </TabPane>
                                <TabPane tabId="2">
                                    <PreferencesCompanyConfigAccreditation  />
                                </TabPane>
                                <TabPane tabId="3">
                                    <PreferencesCompanyConfigAccreditationNotification  />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PreferencesPage;